<template>
  <b-card v-if="!!option" id="page-company-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title
        ><h2>
          {{ $t(getTitle()) }} {{ $t("pages.users.title").toLowerCase() }}
        </h2></b-card-title
      >
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col cols="12" sm="12" md="6">
              <b-form-group :label="$t(label('name'))" label-for="name">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('name'))"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="user.name"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('name'))"
                    :disabled="!isSaveMode"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <b-form-group :label="$t(label('profile'))" label-for="profile">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('profile'))"
                  rules="required"
                >
                  <v-select
                    input-id="profile"
                    ref="profile"
                    v-model="user.guidProfile"
                    :options="allProfiles"
                    label="name"
                    :placeholder="$t(label('profile'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.guid"
                  >
                    <span slot="no-options">{{ $t("sorryOption") }}</span>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <b-form-group
                :label="$t(label('email'))"
                label-for="email"
                rules="required|email"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('email'))"
                  rules="required|email"
                >
                  <b-form-input
                    id="email"
                    v-model="user.email"
                    type="email"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('email'))"
                    :disabled="!isSaveMode"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <b-form-group :label="$t(label('password'))" label-for="password">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('password'))"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="password"
                      v-model="user.password"
                      :type="passwordFieldType"
                      class="form-control-merge"
                      :state="errors.length > 0 ? false : null"
                      :placeholder="$t(label('password'))"
                      :disabled="!isSaveMode"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="12" md="6">
              <b-form-group :label="$t(label('urlPhoto'))" label-for="urlPhoto">
                <b-media class="body-style">
                  <div v-if="!user.urlPhoto">
                    <input
                      id="inputFilePhoto"
                      ref="fileInputPhoto"
                      name="inputFilePhoto"
                      type="file"
                      class="hidden"
                      accept=".png,.jpeg,.jpg"
                      @change="onFileChange($event, 'urlPhoto')"
                      :disabled="!isSaveMode"
                    />
                    <div
                      class="cursor-pointer m-auto cuve text-center border-2 d-flex align-items-center justify-content-center"
                      accept=".png,.jpeg,.jpg"
                      @drop="handleDrop($event, 'urlPhoto')"
                      @dragover="handleDragover"
                      @dragenter="handleDragover"
                      @click="$refs.fileInputPhoto.click()"
                    >
                      <feather-icon
                        icon="UploadCloudIcon"
                        size="20"
                        svg-classes="h-16 w-16 stroke-current text-grey"
                      />
                      <span
                        style="margin-left: 5px"
                        @click.stop="$refs.fileInputPhoto.click()"
                        >{{ $t(label("urlPhoto")) }}
                      </span>
                    </div>
                  </div>

                  <template v-if="user.urlPhoto" #aside>
                    <div class="image-full-screen">
                      <img
                        id="image"
                        ref="image"
                        :src="user.urlPhoto"
                        class="img-avatar border-dashed"
                      />
                    </div>
                    <div
                      v-if="user.urlPhoto && option != 2"
                      class="d-flex flex-wrap"
                      style="width: 10px"
                    >
                      <b-button
                        variant="primary"
                        style="height: 30px; width: 30px; padding: 4px"
                        @click="deleteFile('urlPhoto')"
                        :disabled="!isSaveMode"
                      >
                        <feather-icon icon="XIcon" size="21" />
                      </b-button>
                    </div>
                  </template>
                </b-media>
              </b-form-group>
            </b-col>

            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BAlert,
  BFormSelect,
  BModal,
  BToast,
  BFormRadio,
  BFormRadioGroup,
  BFormInvalidFeedback,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { required, email } from "@validations";
import vSelect from "vue-select";
import { createOrEditUser, showUser } from "@core/api/request/user";
import { postFile } from "@core/api/request/catalogs";
import { allProfiles } from "@core/api/request/profiles";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";

const user = {
  guid: "",
  guidCompany: "",
  guidProfile: "",
  name: "",
  email: "",
  password: "",
  urlPhoto: "",
};

export default {
  components: {
    BFormRadio,
    BFormRadioGroup,
    BAlert,
    BModal,
    ValidationProvider,
    ValidationObserver,
    BInputGroup,
    BInputGroupAppend,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    vSelect,
    BFormTextarea,
    BFormSelect,
    BToast,
    BFormInvalidFeedback,
    VueTelInput,
  },
  directives: {
    Ripple,
  },

  mixins: [togglePasswordVisibility],
  data: () => ({
    companyGuid: null,
    openTelInput: false,
    isSaveMode: true,
    required,
    email,
    option: "",
    user: Object.assign(user),
    allProfiles: [],
    inputTelOption: {
      placeholder: "Ingrese un número de teléfono",
      // showDialCode: true
    },
    idCompany: "",
    companyGuid: "",
    idCatType: "",
  }),

  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },

  created() {
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    localize("es");
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
      this.user.guidCompany = guid;
      if (this.companyGuid) {
        this.getListProfiles();
      }
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {
    label(field) {
      return `pages.users.form.label.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    async initialize() {
      this.option = this.$route.params.option;
      if (this.option === undefined) {
        router.push({ name: "users" }).catch(() => {});
      }

      switch (this.option) {
        case 1:
          this.onCancel();
          this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
          this.user.guidCompany = this.companyGuid;
          this.getListProfiles();
          break;
        case 2:
        case 3:
          if (this.$route.params.guid === undefined) {
            router.push({ name: "users" }).catch(() => {});
          }
          this.isSaveMode = this.option !== 2;
          await this.getListProfiles();
          this.getUser(this.$route.params.guid);
          break;
      }
    },

    onSubmit() {
      console.log("onSubmit", this.user);
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          showLoading();

          const data = {
            guid: this.user.guid,
            guidCompany: this.user.guidCompany,
            guidProfile: this.user.guidProfile,
            name: this.user.name,
            email: this.user.email,
            urlPhoto: this.user.urlPhoto,
          };

          if (this.user.password) data.password = this.user.password;

          const idUser = this.option === 1 ? null : this.user.guid;

          createOrEditUser(data, idUser)
            .then(() => {
              this.goBack();
            })
            .catch((error) => {
              console.log("error", error.message);
              this.alertToast(
                "danger",
                "Error",
                error.message,
                "AlertTriangleIcon",
              );
            })
            .finally(() => {
              stopLoading();
            });
        }
      });
    },

    onDropdownOpen(isOpen) {
      this.openTelInput = isOpen;
    },

    getUser(guid) {
      showLoading();
      showUser(guid)
        .then((resp) => {
          const customers = _.get(resp, "data");
          this.user = Object.assign(this.user, {
            guid: customers.guid || null,
            guidCompany: customers.guidCompany || null,
            guidProfile: customers.guidProfile || null,
            name: customers.name || null,
            email: customers.email || null,
            urlPhoto: customers.photo || null,
          });
          this.idCatType = customers.idCatType;
        })
        .catch((error) => {
          console.log("error", error);
          this.alertToast(
            "danger",
            "Error",
            error.message,
            "AlertTriangleIcon",
          );
        })
        .finally(() => {
          stopLoading();
        });
    },

    getListProfiles() {
      const param = this.chargeParams();
      allProfiles(param)
        .then((resp) => {
          const data = _.get(resp, "data") || [];
          this.allProfiles = data.items ?? [];
          console.log("allProfiles", this.allProfiles);
        })
        .catch((error) => {
          console.log("error", error);
          this.alertToast(
            "danger",
            "Error",
            error.message,
            "AlertTriangleIcon",
          );
        })
        .finally(() => {});
    },

    goBack() {
      this.$refs.simpleRules.reset();
      router.back();
      this.onCancel();
    },

    onCancel() {
      Object.assign(this.user, {
        guid: "",
        guidCompany: "",
        guidProfile: "",
        name: "",
        email: "",
        password: "",
        urlPhoto: "",
      });
      this.idCatType = "";
      this.companyGuid = "";
    },

    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
    deleteFile(field) {
      this.user[field] = null;
    },

    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },

    onFileChange(e, field) {
      if (e?.target?.files?.length > 0) {
        this.onTransFile(
          e?.target?.files,
          e.target.accept,
          e.target.multiple,
          field,
        );
      }
    },

    onTransFile(files, accept, multiple, field) {
      if (multiple) return;
      // this.loadingPhoto = true;
      files.forEach((file) => {
        if (!file) return;
        const type = file.type.split("/").pop();
        const isPdf = type === "pdf";
        const isImage = ["jpeg", "jpg", "png"].includes(type);
        if (!isPdf && !isImage) return;
        showLoading();
        postFile(file)
          .then((resp) => {
            this.user[field] = resp.data;
          })
          .catch(console.error)
          .finally(() => {
            // this.loadingPhoto = false;
            stopLoading();
          });
      });
    },

    handleDrop(e, field) {
      e.stopPropagation();
      e.preventDefault();
      const { files } = e.dataTransfer;
      if (files.length !== 1) {
        return;
      }
      const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
      const file = files[0];
      if (!allowedTypes.includes(file.type)) return;
      const accept =
        e.target.getAttribute("accept") ||
        e.target.parentElement.getAttribute("accept");
      const multiple =
        e.target.getAttribute("multiple") ||
        e.target.parentElement.getAttribute("multiple");
      this.onTransFile(files, ".png,.jpeg,.jpg", false, field);
    },

    chargeParams() {
      const arrParams = [];
      arrParams.push(`page,1`);
      arrParams.push(`rows,999`);
      if (this.companyGuid) arrParams.push(`guidCompany, ${this.companyGuid}`);

      return getParams(arrParams);
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
